export enum TradeSideEnum {
  LONG = 'LONG',
  SHORT = 'SHORT',
  HEDGE_MODE = 'HEDGE_MODE',
}
